module.exports = __webpack_public_path__ + "img/img10.e0064a47.png";